module.exports = __webpack_public_path__ + "img/remarketing.5adf61c2.png";